import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 1C5.93 1 1 5.92 1 12C1 18.08 5.93 23 12 23C18.07 23 23 18.08 23 12C23 5.92 18.07 1 12 1ZM12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.9991 17.8098C12.7613 17.8098 13.3791 17.192 13.3791 16.4298C13.3791 15.6677 12.7613 15.0498 11.9991 15.0498C11.237 15.0498 10.6191 15.6677 10.6191 16.4298C10.6191 17.192 11.237 17.8098 11.9991 17.8098Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 13.4302C12.55 13.4302 13 12.9802 13 12.4302V6.93018C13 6.38018 12.55 5.93018 12 5.93018C11.45 5.93018 11 6.38018 11 6.93018V12.4302C11 12.9802 11.45 13.4302 12 13.4302Z",
          fill: "currentColor"
        }
      )
    ] }) })
  }
);
const IconExclamationmarkCircleLine = forwardRef(Icon);
export default IconExclamationmarkCircleLine;
